import ClusterService from '@/services/cluster.service'
import Utils from '@/utils'

const state = {
    page: {
        results: [],
        count: 0,
        next: null,
        previous: null
    },
    currentCluster: {
        name: 'Carregando...',
        description: ''
    },
    clusterTypes: [] // non paginated route
}

const getters = {}

const actions = {
    create: async ({ commit }, args) => {
        try {
            let res = await ClusterService.create(args)
            commit('createSuccess')
            return res.data
        } catch (e) {
            if (e && e.response) throw e.response.status
            else throw 500
        }
    },

    read: async ({ commit }, args) => {
        if (!args) args = {}
        if (!args.page) args.page = 1
        if (state.page.index == args.page) return true
        try {
            let page = await ClusterService.read(args.id ? args.id : args)
            if (args.id) commit('readCurrentSuccess', page.data)
            else commit('readSuccess', page.data, args.page)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    readClusterTypes: async ({ commit }) => {
        try {
            let page = await ClusterService.readClusterTypes()
            commit('readClusterTypesSuccess', page.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    update: async ({ commit }, args) => {
        try {
            await ClusterService.update(args.id, args)
            commit('updateSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    delete: async ({ commit }, { id }) => {
        try {
            await ClusterService.delete(id)
            commit('deleteSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    deleteBranch: async ({ commit }, { id, branches_id }) => {
        try {
            await ClusterService.deleteBranch(id, branches_id)
            commit('deleteSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    }
}

const mutations = {
    createSuccess(state) {
        // success
    },

    readSuccess(state, page, page_index) {
        Utils.datetimeConverter(page.results)
        state.page = page
        state.page.index = page_index
    },
    readCurrentSuccess(state, entity) {
        state.currentCluster = entity
    },
    readClusterTypesSuccess(state, entity) {
        state.clusterTypes = entity
    },

    updateSuccess(state) {
        // success
    },

    deleteSuccess(state) {
        // success
    }
}

const branches = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default branches
export { branches }
